/**
 * @generated SignedSource<<476545f4b11f7c09b17595b678efa848>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamPickerPopover_storeViewer$data = {
  readonly teams: ReadonlyArray<{
    readonly id: string;
    readonly todoActiveAssignedCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"TeamPickerPopoverItem_team">;
  }>;
  readonly " $fragmentType": "TeamPickerPopover_storeViewer";
};
export type TeamPickerPopover_storeViewer$key = {
  readonly " $data"?: TeamPickerPopover_storeViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamPickerPopover_storeViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamPickerPopover_storeViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "employeeId",
              "variableName": "employeeId"
            }
          ],
          "kind": "ScalarField",
          "name": "todoActiveAssignedCount",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamPickerPopoverItem_team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreViewer",
  "abstractKey": null
};

(node as any).hash = "ec083cdb2eb0c930618ebccb9dd87283";

export default node;
